module.exports = __webpack_public_path__ + "static/img/fwzl.7aa5d189.png";